import { Theme } from '@material-ui/core';

export const muiSelectOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiSelect: {
    icon: {
      color: theme.palette.primary.main,
      width: '2rem',
      height: '2rem',
      top: 'calc(50% - 10px)',
    },
    select: {
      minWidth: '220px',
    },
  },
  MuiMenuItem: {
    selected: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[100],
    },
  },
  MuiOutlinedInput: {
    root: {
      borderRadius: 0,
    },
  },
});
